import React from 'react';
import { Router } from '@uhg-abyss//web/ui/Router';
import { OptOut } from './component/OptOut';
import { OptIn } from './component/OptIn';
import { Optin_recaptcha } from './component/Optin_recaptcha';
import { Optin_cloudflare } from './component/Optin_cloudflare';
import { createTheme } from '@uhg-abyss/web/tools/theme';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider/ThemeProvider';

export const Routes = () => {
    const themeOverride = {  enterpriseFont: true};
  const theme = createTheme('uhc', themeOverride);
  return (
    <ThemeProvider theme={theme}>
    <Router.Routes title="{{title}} | Abyss">
      <Router.Route path="/optin" element={<OptIn />} />
       <Router.Route path="/optin-recaptcha" element={<Optin_recaptcha />} />
       <Router.Route path="/optin-cloudflare" element={<Optin_cloudflare />} />
      <Router.Route path="/optout" element={<OptOut />} />
    </Router.Routes>
    </ThemeProvider>
  );
};
